<div class="bg-white rounded-xl shadow-md py-4 px-4 overflow-visible">
  <!-- Header -->
  <div class="flex justify-between items-center mb-0 pb-[14px] border-b border-gray-200">
    <div *ngIf="isEdit" class="w-2"></div>
    <!-- EMPTY DIV THAYT TAKE THE SPACE OF THE EXTERNAL HANDLER-->

<h3
  class="text-[#002b5b]
         text-[0.7rem]
         xl:text-[0.83rem]
         2xl:text-[0.91rem]"
  [ngClass]="{
    'text-[0.65rem] xl:text-[0.78rem] 2xl:text-[0.86rem] pt-[2px]': isEdit
  }"
>

      {{ title }}
    </h3>

    <!--<button
      type="button"
      class="text-[#002b5b] hover:text-white hover:bg-dimot-1 text-2xl border-1 border-dimot-1 w-[22px] h-[22px] items-center justify-center flex cursor-pointer"
      *ngIf="!isEdit && className === 'widget-attivita'"
      (click)="openModalAddActivity()"
    > + </button>-->
    <div class="flex flex-row gap-1">
   <button
   (click)="generateReport(true)"
         *ngIf="(className === 'widget-curva-accesso' || className === 'widget-curva-mercato') && !isEdit"
          type="button"
          class="group rounded-md border-1 border-[#0A768A] px-2 bg-[#0A768A] hover:bg-white text-white hover:text-[#0A768A] w-[62px] h-[22px] 2xl:w-[74px] 2xl:h-[22px] flex flex-row justify-between items-center cursor-pointer"
        >
          <h5 class="text-[0.5rem] 2xl:text-[0.64rem]">Report</h5>
        
        <svg width="13" height="13" 
         class="block group-hover:hidden w-[11px] h-[11px] 2xl:w-[13px] 2xl:h-[13px]"
        viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.875 9V13C13.875 13.0995 13.8355 13.1948 13.7652 13.2652C13.6948 13.3355 13.5995 13.375 13.5 13.375H2.5C2.40054 13.375 2.30516 13.3355 2.23483 13.2652C2.16451 13.1948 2.125 13.0995 2.125 13V9C2.125 8.90054 2.16451 8.80516 2.23483 8.73483C2.30516 8.66451 2.40054 8.625 2.5 8.625C2.59946 8.625 2.69484 8.66451 2.76517 8.73483C2.83549 8.80516 2.875 8.90054 2.875 9V12.625H13.125V9C13.125 8.90054 13.1645 8.80516 13.2348 8.73483C13.3052 8.66451 13.4005 8.625 13.5 8.625C13.5995 8.625 13.6948 8.66451 13.7652 8.73483C13.8355 8.80516 13.875 8.90054 13.875 9ZM7.735 9.265C7.80531 9.33523 7.90062 9.37467 8 9.37467C8.09938 9.37467 8.19469 9.33523 8.265 9.265L10.765 6.765C10.8312 6.69391 10.8673 6.59989 10.8656 6.50274C10.8639 6.40559 10.8245 6.3129 10.7558 6.24419C10.6871 6.17548 10.5944 6.13613 10.4973 6.13441C10.4001 6.1327 10.3061 6.16876 10.235 6.235L8.375 8.09437V2C8.375 1.90054 8.33549 1.80516 8.26517 1.73483C8.19484 1.66451 8.09946 1.625 8 1.625C7.90054 1.625 7.80516 1.66451 7.73484 1.73483C7.66451 1.80516 7.625 1.90054 7.625 2V8.09437L5.765 6.235C5.69391 6.16876 5.59989 6.1327 5.50274 6.13441C5.40559 6.13613 5.3129 6.17548 5.24419 6.24419C5.17548 6.3129 5.13613 6.40559 5.13441 6.50274C5.1327 6.59989 5.16876 6.69391 5.235 6.765L7.735 9.265Z" fill="white"/>
</svg>

<svg width="13" height="13" 
class="hidden group-hover:block relative top-[2px] left-[2px]"
viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.75 7.375V11.375C11.75 11.4745 11.7105 11.5698 11.6402 11.6402C11.5698 11.7105 11.4745 11.75 11.375 11.75H0.375C0.275544 11.75 0.180161 11.7105 0.109835 11.6402C0.0395088 11.5698 0 11.4745 0 11.375V7.375C0 7.27554 0.0395088 7.18016 0.109835 7.10983C0.180161 7.03951 0.275544 7 0.375 7C0.474456 7 0.569839 7.03951 0.640165 7.10983C0.710491 7.18016 0.75 7.27554 0.75 7.375V11H11V7.375C11 7.27554 11.0395 7.18016 11.1098 7.10983C11.1802 7.03951 11.2755 7 11.375 7C11.4745 7 11.5698 7.03951 11.6402 7.10983C11.7105 7.18016 11.75 7.27554 11.75 7.375ZM5.61 7.64C5.68031 7.71023 5.77562 7.74967 5.875 7.74967C5.97438 7.74967 6.06969 7.71023 6.14 7.64L8.64 5.14C8.70624 5.06891 8.7423 4.97489 8.74059 4.87774C8.73887 4.78059 8.69952 4.6879 8.63081 4.61919C8.5621 4.55048 8.46941 4.51113 8.37226 4.50941C8.27511 4.5077 8.18109 4.54376 8.11 4.61L6.25 6.46937V0.375C6.25 0.275544 6.21049 0.180161 6.14017 0.109835C6.06984 0.0395088 5.97446 0 5.875 0C5.77554 0 5.68016 0.0395088 5.60984 0.109835C5.53951 0.180161 5.5 0.275544 5.5 0.375V6.46937L3.64 4.61C3.56891 4.54376 3.47489 4.5077 3.37774 4.50941C3.28059 4.51113 3.1879 4.55048 3.11919 4.61919C3.05048 4.6879 3.01113 4.78059 3.00941 4.87774C3.0077 4.97489 3.04376 5.06891 3.11 5.14L5.61 7.64Z" fill="#0A778A"/>
</svg>
        </button> 
      <button type="button" class="relative group text-[#002b5b] pl-[9px]" *ngIf="!isEdit">
        <svg fill="#141e58" width="18" height="18" 
        class="w-[15px] h-[15px] xl:w-[18px] xl:h-[18px]"
        viewBox="-6.5 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier">
            <path
              d="m8.436.006c.051-.004.111-.007.172-.007 1.237 0 2.239 1.003 2.239 2.239 0 .041-.001.081-.003.122v-.006c-.079 1.679-1.46 3.01-3.151 3.01-.022 0-.043 0-.065-.001h.003c-.069.008-.15.012-.231.012-1.188 0-2.151-.963-2.151-2.151 0-.088.005-.174.015-.259l-.001.01c.063-1.655 1.419-2.972 3.084-2.972.031 0 .062 0 .093.001h-.005zm-4.947 23.994c-1.268 0-2.199-.783-1.311-4.226l1.456-6.108c.254-.978.295-1.369 0-1.369-1.141.293-2.142.752-3.035 1.359l.033-.021-.633-1.057c3.086-2.622 6.638-4.159 8.158-4.159 1.268 0 1.48 1.526.845 3.874l-1.666 6.421c-.296 1.135-.168 1.526.126 1.526 1.106-.256 2.069-.761 2.863-1.456l-.008.007.72.979c-3.004 3.052-6.281 4.232-7.549 4.232z">
            </path>
          </g>
        </svg>
        <!-- <svg 
    class="block group-hover:hidden"
width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.9375 16.875C12.9375 17.0604 12.8825 17.2417 12.7795 17.3958C12.6765 17.55 12.5301 17.6702 12.3588 17.7411C12.1875 17.8121 11.999 17.8307 11.8171 17.7945C11.6353 17.7583 11.4682 17.669 11.3371 17.5379C11.206 17.4068 11.1167 17.2398 11.0805 17.0579C11.0443 16.876 11.0629 16.6875 11.1339 16.5162C11.2048 16.3449 11.325 16.1985 11.4792 16.0955C11.6333 15.9925 11.8146 15.9375 12 15.9375C12.2486 15.9375 12.4871 16.0363 12.6629 16.2121C12.8387 16.3879 12.9375 16.6264 12.9375 16.875ZM12 6.9375C10.0313 6.9375 8.4375 8.36719 8.4375 10.125V10.5C8.4375 10.6492 8.49677 10.7923 8.60226 10.8977C8.70775 11.0032 8.85082 11.0625 9 11.0625C9.14919 11.0625 9.29226 11.0032 9.39775 10.8977C9.50324 10.7923 9.5625 10.6492 9.5625 10.5V10.125C9.5625 8.98781 10.6556 8.0625 12 8.0625C13.3444 8.0625 14.4375 8.98781 14.4375 10.125C14.4375 11.2622 13.3444 12.1875 12 12.1875C11.8508 12.1875 11.7077 12.2468 11.6023 12.3523C11.4968 12.4577 11.4375 12.6008 11.4375 12.75V13.5C11.4375 13.6492 11.4968 13.7923 11.6023 13.8977C11.7077 14.0032 11.8508 14.0625 12 14.0625C12.1492 14.0625 12.2923 14.0032 12.3978 13.8977C12.5032 13.7923 12.5625 13.6492 12.5625 13.5V13.2731C14.2603 13.0312 15.5625 11.7113 15.5625 10.125C15.5625 8.36719 13.9688 6.9375 12 6.9375ZM21.5625 12C21.5625 13.8913 21.0017 15.7401 19.9509 17.3126C18.9002 18.8852 17.4067 20.1108 15.6594 20.8346C13.9121 21.5584 11.9894 21.7477 10.1345 21.3788C8.27951 21.0098 6.57564 20.099 5.2383 18.7617C3.90096 17.4244 2.99022 15.7205 2.62125 13.8656C2.25227 12.0106 2.44164 10.0879 3.16541 8.34059C3.88917 6.59327 5.11482 5.09981 6.68736 4.04907C8.25991 2.99833 10.1087 2.4375 12 2.4375C14.5352 2.44048 16.9658 3.44891 18.7584 5.24158C20.5511 7.03425 21.5595 9.46478 21.5625 12ZM20.4375 12C20.4375 10.3312 19.9427 8.69992 19.0155 7.31238C18.0884 5.92484 16.7706 4.84338 15.2289 4.20477C13.6871 3.56615 11.9906 3.39906 10.3539 3.72462C8.71722 4.05019 7.2138 4.85378 6.03379 6.03379C4.85379 7.21379 4.05019 8.71721 3.72463 10.3539C3.39907 11.9906 3.56616 13.6871 4.20477 15.2289C4.84338 16.7706 5.92484 18.0884 7.31238 19.0155C8.69992 19.9426 10.3312 20.4375 12 20.4375C14.237 20.435 16.3817 19.5453 17.9635 17.9635C19.5453 16.3817 20.435 14.237 20.4375 12Z" fill="#141F58"/>
</svg>

<svg
    class="hidden group-hover:block"
    width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2172_35480)">
<path d="M12.9375 16.875C12.9375 17.0604 12.8825 17.2417 12.7795 17.3958C12.6765 17.55 12.5301 17.6702 12.3588 17.7411C12.1875 17.8121 11.999 17.8307 11.8171 17.7945C11.6353 17.7583 11.4682 17.669 11.3371 17.5379C11.206 17.4068 11.1167 17.2398 11.0805 17.0579C11.0443 16.876 11.0629 16.6875 11.1339 16.5162C11.2048 16.3449 11.325 16.1985 11.4792 16.0955C11.6333 15.9925 11.8146 15.9375 12 15.9375C12.2486 15.9375 12.4871 16.0363 12.6629 16.2121C12.8387 16.3879 12.9375 16.6264 12.9375 16.875ZM12 6.9375C10.0313 6.9375 8.4375 8.36719 8.4375 10.125V10.5C8.4375 10.6492 8.49677 10.7923 8.60226 10.8977C8.70775 11.0032 8.85082 11.0625 9 11.0625C9.14919 11.0625 9.29226 11.0032 9.39775 10.8977C9.50324 10.7923 9.5625 10.6492 9.5625 10.5V10.125C9.5625 8.98781 10.6556 8.0625 12 8.0625C13.3444 8.0625 14.4375 8.98781 14.4375 10.125C14.4375 11.2622 13.3444 12.1875 12 12.1875C11.8508 12.1875 11.7077 12.2468 11.6023 12.3523C11.4968 12.4577 11.4375 12.6008 11.4375 12.75V13.5C11.4375 13.6492 11.4968 13.7923 11.6023 13.8977C11.7077 14.0032 11.8508 14.0625 12 14.0625C12.1492 14.0625 12.2923 14.0032 12.3978 13.8977C12.5032 13.7923 12.5625 13.6492 12.5625 13.5V13.2731C14.2603 13.0312 15.5625 11.7113 15.5625 10.125C15.5625 8.36719 13.9688 6.9375 12 6.9375ZM21.5625 12C21.5625 13.8913 21.0017 15.7401 19.9509 17.3126C18.9002 18.8852 17.4067 20.1108 15.6594 20.8346C13.9121 21.5584 11.9894 21.7477 10.1345 21.3788C8.27951 21.0098 6.57564 20.099 5.2383 18.7617C3.90096 17.4244 2.99022 15.7205 2.62125 13.8656C2.25227 12.0106 2.44164 10.0879 3.16541 8.34059C3.88917 6.59327 5.11482 5.09981 6.68736 4.04907C8.25991 2.99833 10.1087 2.4375 12 2.4375C14.5352 2.44048 16.9658 3.44891 18.7584 5.24158C20.5511 7.03425 21.5595 9.46478 21.5625 12ZM20.4375 12C20.4375 10.3312 19.9427 8.69992 19.0155 7.31238C18.0884 5.92484 16.7706 4.84338 15.2289 4.20477C13.6871 3.56615 11.9906 3.39906 10.3539 3.72462C8.71722 4.05019 7.2138 4.85378 6.03379 6.03379C4.85379 7.21379 4.05019 8.71721 3.72463 10.3539C3.39907 11.9906 3.56616 13.6871 4.20477 15.2289C4.84338 16.7706 5.92484 18.0884 7.31238 19.0155C8.69992 19.9426 10.3312 20.4375 12 20.4375C14.237 20.435 16.3817 19.5453 17.9635 17.9635C19.5453 16.3817 20.435 14.237 20.4375 12Z" fill="#6A7282"/>
<g filter="url(#filter0_d_2172_35480)">
</g>
</g>
<defs>
<filter id="filter0_d_2172_35480" x="-62" y="-52" width="148" height="53" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feMorphology radius="1" operator="erode" in="SourceAlpha" result="effect1_dropShadow_2172_35480"/>
<feOffset dy="4"/>
<feGaussianBlur stdDeviation="3"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2172_35480"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2172_35480" result="shape"/>
</filter>
<clipPath id="clip0_2172_35480">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>-->

        <div
          class="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 text-sm text-white bg-[#002b5b] rounded-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 whitespace-normal break-words text-[0.6rem] 2xl:text-[0.7rem] 3xl:text-[0.75rem] text-center z-50 pointer-events-none"
          [ngClass]="getTooltipWidthClass()">
          {{ getTooltipText() }}
          <div
            class="absolute top-full left-[calc(50%+5px)] -translate-x-1/2 border-4 border-transparent border-t-[#002b5b]">
          </div>
        </div>

      </button>
      
   <!-- This version open the modal
    <button class="text-[#002b5b] cursor-pointer" *ngIf="isEdit" (click)="openModalDelete(true)">
        <img src="../../../../../assets/img/Icons/close-lg-svgrepo-com.svg" width="20" height="20" />
      </button>  --> 
      <button class="text-[#002b5b] cursor-pointer" *ngIf="isEdit" (click)="onDelete()">
        <img src="../../../../../assets/img/Icons/close-lg-svgrepo-com.svg"
         width="20" height="20"
         class="w-[14px] h-[14px] xl:w-[20px] xl:h-[20px]"
         />
      </button> 
    </div>
  </div>
  <!-- HERE IS WHERE WE WILL LOAD THE WIDGET INSTEAD OF IMGs -->
  <div *ngIf="className == 'widget-esperienze-map'" class="w-[252px] h-[320px] xl:w-[310px] xl:h-[394px] 2xl:w-[384px] 2xl:h-[488px] mt-4">


    <!--To replace <img
      src="../../../../../assets/img/widgetsPreview/esperienzeMap.png"
      width="380"
    />-->
    <app-potential-per-region-map></app-potential-per-region-map>
  </div>
  <div *ngIf="className == 'widget-heatmap'" class="w-[252px] h-[320px] xl:w-[310px] xl:h-[394px] 2xl:w-[384px] 2xl:h-[488px] mt-4">
    <!--To replace <img
      src="../../../../../assets/img/widgetsPreview/heatmap.png"
      width="380"
    />-->

    <app-heatmap-inclusion-process></app-heatmap-inclusion-process>
  </div>


  <!--  TO UNCOMMENT WHEN READY -->
  <div *ngIf="className == 'widget-mapOpenAccess'" class="w-[252px] h-[320px] xl:w-[310px] xl:h-[394px] 2xl:w-[384px] 2xl:h-[488px] mt-4">

    <app-map-open-to-access-regions></app-map-open-to-access-regions>
  </div>


  <div class="w-[408px] h-[269px] xl:w-[492px] xl:h-[308px] 2xl:w-[600px] 2xl:h-[308px]" *ngIf="className == 'widget-attivita'" 
  
  [ngClass]="{ '2xl:w-[800px] 2xl:h-[400px]': extendWidget }">
    <!--To replace <img
      src="../../../../../assets/img/widgetsPreview/attivita.png"
      width="380"
    />-->
    <app-regional-access-activity-plan-table
      (openModalAddActivities)="openModalAddActivity(true)"></app-regional-access-activity-plan-table>
  </div>
  <div class="mt-4 w-[406px] xl:w-[490px] 2xl:w-[610px]" *ngIf="className == 'widget-curva-accesso'" [ngClass]="{ '2xl:w-[720px]': extendWidget }">
    <!--To replace <img
      src="../../../../../assets/img/widgetsPreview/curvaDiAccesso - Copia.png"
      width="600"
    />-->

    <app-open-to-access-curve [lineColor1]="'#003580'" [lineColor2]="'#00CEBC'">
      ></app-open-to-access-curve>
  </div>
  <div *ngIf="className == 'widget-curva-mercato'" class="mt-4 w-[406px] xl:w-[490px] 2xl:w-[610px]" [ngClass]="{
      '2xl:w-[720px]': extendWidget
    }">
    <!--To replace <img
      src="../../../../../assets/img/widgetsPreview/curvaDiMercato - Copia.png"
      width="600"
    />-->

    <app-open-to-market-curve [lineColor1]="'#003580'" [lineColor2]="'#00CEBC'"></app-open-to-market-curve>
  </div>

  <div *ngIf="className == 'widget-evolution-regional-access'"
    class="w-[868px] xl:w-[1040px] 2xl:w-[1280px] mt-4"
      [ngClass]="{
    'h-[100px] 2xl:h-[160px]': !isEvoluzioneTwoRowsLayout,
    'h-[180px] 2xl:h-[330px]': isEvoluzioneTwoRowsLayout
  }"
    >
    <!--To replace <img
      src="../../../../../assets/img/widgetsPreview/curvaDiMercato - Copia.png"
      width="600"
    />-->

    <app-evolution-regional-access
    (isTwoRowLayout)="isEvoluzioneTwoRowsLayout = $event">
    </app-evolution-regional-access>
  </div>


  <div *ngIf="className == 'widget-monitoringForecastVsActualRegionalLevel'" class="w-[408px] h-[269px] xl:w-[492px] xl:h-[308px] 2xl:w-[600px] 2xl:h-[308px]" 
  [ngClass]="{
      '2xl:w-[800px] 2xl:h-[400px]': extendWidget
    }">
    <!--To replace <img
      src="../../../../../assets/img/widgetsPreview/attivita.png"
      width="380"
    />-->

    <app-monitoring-forecast-vs-actual-regional-level></app-monitoring-forecast-vs-actual-regional-level>
  </div>

  <div *ngIf="className == 'widget-forecastTimeProgress'" class="w-[408px] h-[269px] xl:w-[492px] xl:h-[308px] 2xl:w-[600px] 2xl:h-[308px]"
   [ngClass]="{
      '2xl:w-[800px] 2xl:h-[400px]': extendWidget
    }">
    <!--To replace <img
      src="../../../../../assets/img/widgetsPreview/attivita.png"
      width="380"
    />-->

    <app-nt-forecast-time-progress></app-nt-forecast-time-progress>
  </div>

  <div *ngIf="className == 'widget-nHospitalsAndExperiences'"  class="w-[408px] h-[269px] xl:w-[492px] xl:h-[308px] 2xl:w-[600px] 2xl:h-[308px]" 
  [ngClass]="{
      '2xl:w-[800px] h-[400px]': extendWidget
    }">

    <!-- vertical 
       <div *ngIf="className == 'widget-nHospitalsAndExperiences'" class="w-96 mt-4"
    [ngClass]="{ '2xl:w-[720px] 2xl:h-[350px]': extendWidget }">
    -->

    <!--To replace <img
      src="../../../../../assets/img/widgetsPreview/heatmap.png"
      width="380"
    />-->

    <app-n-hospitals-and-experiences></app-n-hospitals-and-experiences>
  </div>

</div>

<!-- Delete modal -->
<!--<div *ngIf="deleteModalOpen"
  class="fixed inset-0 isolate z-[1000] flex items-center justify-center bg-black/50 backdrop-blur-xs p-4">
  <div class="relative bg-white rounded-lg p-6 max-w-md w-full">
    <button (click)="openModalDelete(false)"
      class="absolute top-2 right-4 text-gray-500 hover:text-black cursor-pointer">
      ✕
    </button>

    <div class="z-[999] flex flex-col items-center justify-center text-center gap-6 py-4">
      <img src="../../../../../assets/img/Icons/delete-widget.svg" width="60" height="60" class="mx-auto" />
      <span class="text-gray-700">Sei sicuro di voler nascondere questo widget?</span>
      <button (click)="onDelete()"
        class="bg-dimot-3 w-34 h-10 hover:bg-gray-700 text-[1em] 2xl:text-xs text-white rounded-md cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed">
        Elimina
      </button>
    </div>
  </div>
</div> -->

<app-loading-generation *ngIf="generateExcel" [widgetName]="className"></app-loading-generation>

<app-generate-excel *ngIf="canGenerateExcel" [widgetName]="className"
  (sendEndMessage)="onEndMessage($event)"></app-generate-excel>